import { render, staticRenderFns } from "./DirectThread.vue?vue&type=template&id=a4416b00&scoped=true"
import script from "./DirectThread.vue?vue&type=script&lang=js"
export * from "./DirectThread.vue?vue&type=script&lang=js"
import style0 from "./DirectThread.vue?vue&type=style&index=0&id=a4416b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4416b00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VSpacer})
